module.exports = __webpack_public_path__ + "img/code5.173477f7.png";